import { Modal, Table } from "react-bootstrap";
import { OMSButtonStyleL } from "../../../app/common/common-components/OMSButton";

const UserCreditHistoryModal = ({ isOpen, onClose, rowData }) => {
  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{  color: 'var(--color2)' }}>
          User's Credit History
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: 350, overflowY: 'auto'}}>
        <Table hover responsive>
          <thead>
            <tr>
              <th>Date</th>
              <th>Remark</th>
              <th>Credit</th>
            </tr>
          </thead>
          <tbody>
            {rowData?.length === 0 ? (
              <tr>
                <td colSpan={3} className="text-center">
                  No credit history found
                </td>
              </tr>
            ) : (
              rowData?.map((data, index) => (
                <tr key={index}>
                  <td>{data.creditedOn}</td>
                  <td>{data.usageType}</td>
                  <td>{data.creditUsed}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
         <OMSButtonStyleL type="button" ui_icon="" ui_type="save" ui_text="Close" ui_processing_text="" processing={false} disabled={false} onClick={onClose} />
      </Modal.Footer>
    </Modal>
  );
};

export default UserCreditHistoryModal;